import { title } from "process";
import { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";

const AddMoreOption = ({title,heading, objectKey, details, handelChange, handleRemove, addMore }) => {

    return <div className='resource-person'>
        <h4>{heading}</h4>
        <div className='resource-person-form'>
            {details?.map((x, i) => {
                return <Row>
                <Form.Label style={{ color: "black",fontWeight: "bold" }}>{title}</Form.Label>
                {Object.keys(x).map((name)=>{
                    return <Col md={3}>
                    <Form.Group >
                        <Form.Label style={{ color: "white" }}>{name}<span style={{color:'rgb(240, 68, 56)'}}>*</span></Form.Label>
                        <Form.Control
                            type="text"
                            name={name}
                            value={x[name]}
                            onChange={e => handelChange(e, i,objectKey)}
                            placeholder={'Enter '+name}
                            required
                        />
                    </Form.Group>
                </Col>
                })}
                <div className="add-more-field">
                    {details.length !== 1 && <button type="button"
                        onClick={() => handleRemove(i,objectKey)}
                    >
                        <img src='../../../../images/remove-icon.png' alt='RemoveIcon' />
                        Remove</button>}
                    {details.length - 1 === i && <button type="button"
                        onClick={() => addMore(objectKey)}
                    >
                        <img src='../../../../images/add-more.png' alt='AddIcon' />
                        Add
                    </button>}
                </div>
                </Row>
                
                
            })}
        </div>
        </div>
}

export default AddMoreOption;
